import axios from "axios";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import dashboardArtBoardPlaceholder from "../../assets/images/dashboardArtBoardPlaceholder.png";
import {
  selectCard,
  unSelectCard,
  moveToFolder,
  createNewFolder,
  removeFolderContent,
} from "../../_actions/folderActions";
import {
  cloneStory,
  cloneTemplate,
  deleteStory,
  updateStory,
  fetchStories,
} from "../../_actions/storiesActions";
import {
  convertPixelToFloat,
} from "../../_utils/common";
import { PREVIEW, STORY_DETAIL } from "../../_utils/routes";
import EditableLabel from "../common/EditableLabel";
import {
  TldrUserInfoView,
  TldrConfirmationModal,
  TldrProgressDialog,
} from "../common/statelessView";
import TLDRImage from "../common/TLDRImage";
import {
  PLACEHOLDER_IMAGE_SIZE,
  StoryActions,
  TAB_CALENDAR_MEDIA,
  TAB_MY_FOLDERS,
  TAB_MY_STORIES,
  TAB_PUBLISHING,
  TAB_TEMPLATES,
} from "../details/constants";
import {
  TldrCheckbox,
  TldrNewFolderDialog,
} from "../styled/home/statelessView";
import { StyledDesignCard } from "../styled/styles";
import TLDRDownloadOptionsWrapper from "../details/downloadArtboards/TLDRDownloadOptionsWrapper";
import {
  ContentTypes,
  TypeOfDesignToBePublished,
} from "../../_utils/constants";
import { setDesignToPublish } from "../../_actions/plannerActions";
import {
  FaArrowAltCircleDown,
  FaArrowAltCircleUp,
  FaCopy,
  FaEllipsisV,
  FaEye,
  FaFileDownload,
  FaPencilAlt,
  FaTrash,
} from "react-icons/fa";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Icon,
  MenuDivider,
  VStack,
  Text,
  Spinner,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Divider,
  Portal,
  Tooltip,
} from "@chakra-ui/react";
import TldrMoveToFolderModal from "./TldrMoveToFolderModal";
import { resetPage } from "../../_actions/sidebarSliderActions";
import { withTranslation } from "react-i18next";
import { ReactComponent as IconMotion } from "../../assets/icons/motion.svg";
import { isMobileView, openUrl } from '@simplified-workspace/shared/util';

const format = require("string-format");

const storyTitleInMenuStyles = () => {
  return {
    fontWeight: "400",
    width: "100%",
    color: "gray.100",
    fontSize: "0.875rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };
};

const storyFormatInMenuStyles = () => {
  return {
    fontWeight: "normal",
    color: "gray.300",
    fontSize: "0.75rem",
    letterSpacing: "0",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginTop: "0 !important",
  };
};

export class StoryCard extends Component {
  signal = axios.CancelToken.source();
  constructor(props) {
    super(props);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.actionClickHandler = this.actionClickHandler.bind(this);
    this.onClick = this.onClick.bind(this);
    this.state = {
      isHovering: false,
      showConfirmation: false,
      inProgress: false,
      showCloneModal: false,
      isChecked: false,
      isTitleHovering: false,
      isDownloading: false,
      showStoryActions: false,
      showExportStoryModal: false,
      showMoveToFolderModal: false,
      showNewFolderModal: false,
      showRemoveFromFolderModal: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const storyId = this.props.story.content_id || this.props.story.id;

    if (this.props !== prevProps) {
      this.setState({
        isChecked: this.props.selectedCards.find(
          (item) => item.content_id === storyId
        ),
      });
    }
  }

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }

  handleMouseEnter() {
    this.setState({
      isHovering: true,
    });
  }

  handleMouseLeave() {
    this.setState({
      isHovering: false,
    });
  }

  preview = () => {
    const { story } = this.props;
    const storyOrg = story.org || story.organization;
    const storyId = story.content_id || story.id;

    const previewUrl = format(PREVIEW, storyOrg, storyId);
    openUrl(encodeURI(previewUrl), "_blank");
  };

  actionClickHandler = (action) => {
    const { story } = this.props;
    const storyOrg = story.org || story.organization;
    const storyId = story.content_id || story.id;
    const storyName = story.content_name || story.title;

    if (action === StoryActions.DELETE) {
      this.setState({
        showConfirmation: true,
      });
    } else if (action === StoryActions.EDIT) {
      const editStoryUrl = format(
        STORY_DETAIL,
        storyOrg,
        storyId,
        encodeURIComponent(storyName)
      );
      this.props.history.push(editStoryUrl);
    } else if (
      action === StoryActions.CLONE &&
      this.props.tab === TAB_MY_STORIES
    ) {
      const workspaceId = Number(storyOrg);

      this.setState({
        inProgress: true,
        showCloneModal: true,
      });
      this.props
        .cloneStory(workspaceId, storyId, this.signal, this.props, true)
        .then(() => {
          this.setState({
            inProgress: false,
            showCloneModal: false,
          });
        });
    } else if (
      action === StoryActions.CLONE &&
      this.props.tab === TAB_TEMPLATES
    ) {
      this.setState({
        inProgress: true,
        showCloneModal: true,
      });
      this.props
        .cloneTemplate(storyId, this.signal, this.props, true)
        .then(() => {
          this.setState({
            inProgress: false,
            showCloneModal: false,
          });
        });
    } else if (action === StoryActions.PREVIEW) {
      this.preview();
    }
  };

  onClick = (e) => {
    const { isChecked } = this.state;
    const { tab, story, history, selectedCards } = this.props;

    if (selectedCards.length > 0) {
      this.onCardClickHandler(!isChecked);
      return;
    }

    const storyOrg = story.org || story.organization;
    const storyId = story.content_id || story.id;
    const storyName = story.content_name || story.title;

    const editStoryUrl = format(
      STORY_DETAIL,
      storyOrg,
      storyId,
      encodeURIComponent(storyName)
    );
    if (tab === TAB_CALENDAR_MEDIA) {
      return;
    } else if (tab === TAB_MY_FOLDERS) {
      return;
    } else if (tab === TAB_MY_STORIES) {
      history.push(encodeURI(editStoryUrl));
    } else if (tab === TAB_PUBLISHING) {
      this.props.setDesignToPublish(
        {
          source: this.props.story.image,
          id: storyId,
        },
        TypeOfDesignToBePublished.PROJECT
      );
      history.push(encodeURI(editStoryUrl));
    } else {
      this.setState({
        inProgress: true,
        showCloneModal: true,
      });
      this.props.cloneTemplate(storyId, this.signal, this.props).then(() => {
        this.setState({
          inProgress: false,
          showCloneModal: false,
        });
      });
    }
  };

  onCardClickHandler = (isChecked) => {
    const { story } = this.props;
    const storyId = story.content_id || story.id;
    const selectedStory = {
      content_type: ContentTypes.STORY,
      content_id: storyId,
    };

    if (isChecked) {
      this.props.selectCard(selectedStory);
    } else {
      this.props.unSelectCard(selectedStory);
    }
    this.setState({ isChecked });
  };

  handleTitleMouseEnter = () => {
    this.setState({ isTitleHovering: true });
  };

  handleTitleMouseLeave = () => {
    this.setState({ isTitleHovering: false });
  };

  handleProjectNameFocus = (text) => { };

  handleProjectNameFocusOut = (text) => {
    const { story } = this.props;
    const storyId = story.content_id || story.id;
    const storyName = story.content_name || story.title;

    if (text === storyName) {
      return;
    }

    this.props.updateStory(storyId, { title: text }, this.signal, this.props);
  };

  onDownloading = (downloading) => {
    this.setState({
      isDownloading: downloading,
      showExportStoryModal: false,
    });
  };

  handleMoveToFolder = (id, name) => {
    const { story } = this.props;
    const storyId = story.content_id || story.id;
    const payload = {
      content_ids: [storyId],
    };

    this.props.resetPage("");

    this.props
      .moveToFolder(payload, id, name, this.signal.token)
      .then((res) => {
        this.setState(
          {
            showMoveToFolderModal: false,
            inProgress: false,
          },
          () => {
            if (this.props.onActionComplete) {
              this.props.onActionComplete();
            } else {
              this.props.fetchStories("", "", 1, { ...this.props });
            }
          }
        );
      })
      .catch((error) => {
        this.setState({
          showMoveToFolderModal: false,
          inProgress: false,
        });
      });
  };

  handleCreateNewFolder = (name) => {
    this.props
      .createNewFolder(name, this.signal.token, this.props)
      .then((folder) => {
        this.setState(
          {
            showNewFolderModal: false,
            inProgress: false,
          },
          () => {
            this.handleMoveToFolder(folder.id, folder.name);
          }
        );
      })
      .catch(() => {
        this.setState({
          showNewFolderModal: false,
          inProgress: false,
        });
      });
  };

  handleRemoveFromFolder = () => {
    const { story, currentFolderId } = this.props;
    const storyId = story.content_id || story.id;
    const payload = {
      remove_content_ids: [storyId],
    };

    this.props.resetPage("");

    this.props
      .removeFolderContent(currentFolderId, payload, this.signal.token)
      .then((res) => {
        this.setState(
          {
            showRemoveFromFolderModal: false,
            inProgress: false,
          },
          () => {
            if (this.props.onActionComplete) {
              this.props.onActionComplete();
            } else {
              this.props.fetchStories("", "", 1, { ...this.props });
            }
          }
        );
      })
      .catch(() => {
        this.setState({
          showRemoveFromFolderModal: false,
          inProgress: false,
        });
      });
  };

  render() {
    const {
      showConfirmation,
      inProgress,
      showCloneModal,
      isHovering,
      isChecked,
      isTitleHovering,
      isDownloading,
      showExportStoryModal,
      showMoveToFolderModal,
      showNewFolderModal,
      showRemoveFromFolderModal,
    } = this.state;
    const {
      story,
      template,
      enableCardSelection,
      height,
      workspacePermissionChecks,
      showDownloadOption,
      authUser,
      showKebabMenu,
      className,
      currentFolderId,
      showRemoveFromFolder,
      showExtraOptions,
      t,
    } = this.props;
    const { canDeleteStory, canEditStory, canViewStory, canCreateStory } =
      workspacePermissionChecks;
    const { status, image, last_updated, image_height, image_width, creator, story_type } =
      story;

    const storyId = story.content_id || story.id;
    const storyName = story.content_name || story.title;
    const editStoryUrl = format(STORY_DETAIL, storyId);
    const isStoryCreator = story?.creator?.id === authUser.pk;
    const imageWidth = convertPixelToFloat(
      PLACEHOLDER_IMAGE_SIZE[template]
        ? PLACEHOLDER_IMAGE_SIZE[template].width
        : `${image_width}px`
    );
    const imageHeight = convertPixelToFloat(
      PLACEHOLDER_IMAGE_SIZE[template]
        ? PLACEHOLDER_IMAGE_SIZE[template].height
        : `${image_height}px`
    )

    return (
      <StyledDesignCard
        varient={template}
        allowOverflow={enableCardSelection}
        cardHeight={height}
        className={className}
      >
        <div
          className="thumbnail"
          style={{ position: "relative" }}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          onClick={this.onClick}
        >
          <div className="placeholder">
            {image ? (
              <TLDRImage
                src={image}
                alt={storyName}
                width={imageWidth}
                height={imageHeight}
              />
            ) : (
              <img src={dashboardArtBoardPlaceholder} alt=""></img>
            )}
          </div>
          {showKebabMenu &&
            ((isHovering && !isMobileView()) || isMobileView()) && (
              <div className="actions" onClick={(e) => e.stopPropagation()}>
                <Menu isLazy>
                  <MenuButton
                    as={IconButton}
                    icon={<Icon as={FaEllipsisV} />}
                    minW="0"
                    h="0"
                    display="flex"
                    sx={{
                      ":focus": {
                        boxShadow: "none",
                      },
                    }}
                  />
                  <Portal>
                    <MenuList>
                      <MenuItem isFocusable={false}>
                        <VStack align="flex-start" maxW="180px">
                          <Text isTruncated sx={storyTitleInMenuStyles()}>
                            {storyName}
                          </Text>
                          <Text sx={storyFormatInMenuStyles()}>{template}</Text>
                        </VStack>
                      </MenuItem>
                      <MenuDivider color="gray.300" />
                      {status === "draft" && canEditStory && (
                        <MenuItem
                          icon={<FaPencilAlt />}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.actionClickHandler(StoryActions.EDIT);
                          }}
                        >
                          {t("edit", { ns: "common" })}
                        </MenuItem>
                      )}
                      {canCreateStory && (
                        <MenuItem
                          icon={<FaCopy />}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.actionClickHandler(StoryActions.CLONE);
                          }}
                        >
                          {t("clone", { ns: "common" })}
                        </MenuItem>
                      )}
                      {canViewStory && (
                        <MenuItem
                          icon={<FaEye />}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.actionClickHandler(StoryActions.PREVIEW);
                          }}
                        >
                          {t("preview", { ns: "common" })}
                        </MenuItem>
                      )}
                      {showDownloadOption && (
                        <MenuItem
                          icon={<FaFileDownload />}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.setState({ showExportStoryModal: true });
                          }}
                        >
                          {t("download", { ns: "common" })}
                        </MenuItem>
                      )}
                      {showExtraOptions && (
                        <MenuItem
                          icon={<FaArrowAltCircleUp />}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.setState({
                              showMoveToFolderModal: true,
                            });
                          }}
                        >
                          {t("move_to_folder.action")}
                        </MenuItem>
                      )}
                      {showExtraOptions && showRemoveFromFolder && (
                        <MenuItem
                          icon={<FaArrowAltCircleDown />}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.setState({
                              showRemoveFromFolderModal: true,
                            });
                          }}
                        >
                          {t("move_back.action")}
                        </MenuItem>
                      )}
                      {status === "draft" &&
                        (canDeleteStory || isStoryCreator) && (
                          <MenuItem
                            icon={<FaTrash />}
                            onClick={(e) => {
                              e.stopPropagation();
                              this.actionClickHandler(StoryActions.DELETE);
                            }}
                          >
                            {t("delete", { ns: "common" })}
                          </MenuItem>
                        )}
                    </MenuList>
                  </Portal>
                </Menu>
              </div>
            )}

          {(isHovering || isChecked) &&
            enableCardSelection &&
            canDeleteStory ? (
            <div className="card-selection">
              <TldrCheckbox
                checked={isChecked}
                onCheck={this.onCardClickHandler}
                hasAbsolutePosition
                description={isChecked ? "Unselect" : "Select"}
              />
            </div>
          ) : null}

          {this.props.selectedCards.length > 0 && (
            <div className="card-selection">
              <TldrCheckbox
                checked={isChecked}
                onCheck={this.onCardClickHandler}
                hasAbsolutePosition
                description={isChecked ? "Unselect" : "Select"}
              />
            </div>
          )}

          {isDownloading && (
            <div className="download-wrapper">
              <Spinner size="lg" color="primary.200" />
            </div>
          )}
        </div>

        <div className="info">
          {!isStoryCreator && (
            <div className="creator">
              <TldrUserInfoView user={creator} />
            </div>
          )}
          <div className="project">
            <div
              className="title"
              onMouseEnter={this.handleTitleMouseEnter}
              onMouseLeave={this.handleTitleMouseLeave}
            >
              <EditableLabel
                text={storyName}
                labelClassName="projectnamevalue"
                inputClassName="projectnameinput"
                onFocus={this.handleProjectNameFocus}
                onFocusOut={this.handleProjectNameFocusOut}
                showIcon={isTitleHovering}
                inputMaxLength={100}
                labelPlaceHolder={t("project_name")}
                labelTextClassName="project-name-label"
              />
            </div>

            <div className="subtitle">
              {t("updated_ago", { last_updated: last_updated })}
            </div>
          </div>
          {story_type === "Animated" ? (
            <Tooltip placement="bottom" label="Animated story" hasArrow>
              <Icon ml={2} color="brand.white">
                <IconMotion />
              </Icon>
            </Tooltip>
          ) : null}
        </div>

        <TldrConfirmationModal
          modalFor={"story"}
          inProgress={inProgress}
          show={showConfirmation}
          onHide={() => {
            this.setState({
              ...this.state,
              showConfirmation: false,
            });
          }}
          onYes={() => {
            this.setState({
              inProgress: true,
            });
            this.props
              .deleteStory(storyId, this.signal, this.props)
              .then(() => {
                this.setState({
                  ...this.state,
                  showConfirmation: false,
                });

                if (this.props.onActionComplete) {
                  this.props.onActionComplete();
                }
              })
              .catch(() => {
                this.setState({
                  ...this.state,
                  showConfirmation: false,
                });
              });
          }}
        />

        <TldrProgressDialog
          inProgress={inProgress}
          show={showCloneModal}
          onHide={() => {
            this.setState({
              ...this.state,
              showCloneModal: false,
            });
          }}
          onYes={() => {
            this.setState({
              inProgress: true,
            });
            this.props.deleteStory(storyId, this.signal, this.props);
          }}
        />

        {showExportStoryModal ? (
          <div onClick={(e) => e.stopPropagation()}>
            <Modal
              isOpen={showExportStoryModal}
              onClose={() => this.setState({ showExportStoryModal: false })}
              isCentered
              closeOnOverlayClick={false}
            >
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>
                  {t("download", { ns: "common" })} {storyName}
                </ModalHeader>
                <ModalCloseButton />
                <Divider />
                <ModalBody p="0 1.5rem 1rem 1.5rem">
                  <TLDRDownloadOptionsWrapper
                    story={{
                      payload: story,
                      contentSize: {
                        width: story.image_width,
                        height: story.image_height,
                      },
                    }}
                    onDownloading={this.onDownloading}
                    onArtBoardsSelectionChange={this.onArtBoardsSelectionChange}
                    show={true}
                    inline
                  />
                </ModalBody>
              </ModalContent>
            </Modal>
          </div>
        ) : null}

        {showMoveToFolderModal ? (
          <div onClick={(e) => e.stopPropagation()}>
            <TldrMoveToFolderModal
              inProgress={inProgress}
              show={showMoveToFolderModal}
              onHide={() => {
                this.setState({
                  showMoveToFolderModal: false,
                });
              }}
              onYes={(folderId, folderName) => {
                this.setState(
                  {
                    inProgress: true,
                  },
                  () => this.handleMoveToFolder(folderId, folderName)
                );
              }}
              onAddFolder={() => {
                this.setState({
                  showNewFolderModal: true,
                  showMoveToFolderModal: false,
                });
              }}
              currentFolderId={currentFolderId}
            />
          </div>
        ) : null}

        {showNewFolderModal ? (
          <TldrNewFolderDialog
            inProgress={inProgress}
            show={showNewFolderModal}
            onHide={() => {
              this.setState({
                showNewFolderModal: false,
              });
            }}
            onYes={(name) => {
              this.setState(
                {
                  inProgress: true,
                },
                () => this.handleCreateNewFolder(name)
              );
            }}
          />
        ) : null}

        {showRemoveFromFolderModal ? (
          <TldrConfirmationModal
            inProgress={inProgress}
            show={showRemoveFromFolderModal}
            customMessage={t("move_back.heading", { name: storyName })}
            customBodyMessage={t("move_back.message")}
            customPrimaryActionText={t("move_back_button.text")}
            onHide={() => {
              this.setState({ showRemoveFromFolderModal: false });
            }}
            onYes={() => {
              this.setState(
                {
                  inProgress: true,
                },
                () => this.handleRemoveFromFolder()
              );
            }}
          />
        ) : null}
      </StyledDesignCard>
    );
  }
}

StoryCard.propTypes = {
  story: PropTypes.object.isRequired,
};

StoryCard.defaultProps = {
  showKebabMenu: true,
  className: "",
  currentFolderId: undefined,
  showRemoveFromFolder: false,
  showExtraOptions: false,
};

const mapStateToProps = (state) => ({
  errors: state.errors,
  isPanelShowing: state.folders.isPanelShowing,
  selectedCards: state.folders.selectedCards,
  workspacePermissionChecks: state?.permissions?.workspacePermissionChecks,
  authUser: state?.auth?.payload?.user,
  selectedCards: state.folders.selectedCards,
});

const mapDispatchToProps = {
  deleteStory,
  cloneStory,
  cloneTemplate,
  selectCard,
  unSelectCard,
  updateStory,
  setDesignToPublish,
  fetchStories,
  moveToFolder,
  resetPage,
  createNewFolder,
  removeFolderContent,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation(["folders", "common"])(StoryCard)));
